import { PRIVATEPATHS } from '@core/enums/paths.enum';
import React, { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';

const TABS = [
    { path: PRIVATEPATHS.As2Messages, label: 'Messages', match: (p: string) => p === PRIVATEPATHS.As2Messages || (p.startsWith(`${PRIVATEPATHS.As2Messages}/`) && !p.includes('/partners')) },
    { path: PRIVATEPATHS.As2Partners, label: 'Partners', match: (p: string) => p === PRIVATEPATHS.As2Partners },
    { path: PRIVATEPATHS.Integrations, label: 'Setup & health', match: (p: string) => p === PRIVATEPATHS.Integrations },
] as const;

const tabClass = (active: boolean) =>
    `rounded-t-md border-b-2 px-4 py-2 text-sm font-medium transition-colors ${
        active
            ? 'border-[#bd902e] text-[#bd902e] bg-amber-50/80'
            : 'border-transparent text-slate-600 hover:border-slate-300 hover:text-slate-900'
    }`;

const As2SectionNav: FC = () => {
    const { pathname } = useLocation();

    return (
        <nav className="mb-4 flex flex-wrap gap-1 border-b border-slate-200" aria-label="AS2 section">
            {TABS.map((tab) => (
                <Link key={tab.path} to={tab.path} className={tabClass(tab.match(pathname))}>
                    {tab.label}
                </Link>
            ))}
        </nav>
    );
};

export default As2SectionNav;
